/**
 * Status Icons - Dark professional SVG icons
 * Replaces emoji icons with subtle, professional SVG icons
 */
import React from 'react';

// Queued - Clock icon
export const QueuedIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

// Running - Bolt/Activity icon
export const RunningIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
  </svg>
);

// Completed - Check circle icon
export const CompletedIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

// Failed - X circle icon
export const FailedIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

// Unknown - Question mark circle
export const UnknownIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
  </svg>
);

// Status icon component that returns the appropriate icon based on status
const StatusIcon = ({ status, className = "w-5 h-5" }) => {
  const iconProps = { className };

  switch (status) {
    case 'queued':
      return <QueuedIcon {...iconProps} />;
    case 'running':
      return <RunningIcon {...iconProps} />;
    case 'completed':
      return <CompletedIcon {...iconProps} />;
    case 'failed':
      return <FailedIcon {...iconProps} />;
    default:
      return <UnknownIcon {...iconProps} />;
  }
};

// Color classes for each status - muted/dark theme colors
export const getStatusColorClass = (status) => {
  const colors = {
    queued: 'text-dark-400',
    running: 'text-dark-300',
    completed: 'text-dark-300',
    failed: 'text-dark-400',
  };
  return colors[status] || 'text-dark-500';
};

// Background color classes for badges - subtle dark theme
export const getStatusBgClass = (status) => {
  const colors = {
    queued: 'bg-dark-700 text-dark-300',
    running: 'bg-dark-700 text-dark-200',
    completed: 'bg-dark-700 text-dark-200',
    failed: 'bg-dark-700 text-dark-300',
  };
  return colors[status] || 'bg-dark-700 text-dark-400';
};

export default StatusIcon;
